<template>
    <modal class="base-modal" 
        :show.sync="value.show"
        :size="size"
        :body-classes="bodyClasses"
        :modal-classes="modalClasses"
        :modal-content-classes="modalContentClasses"
        :loading="loading"
        :backdrop="backdrop"
        :animationDuration="animationDuration"
        :centered="centered"
    >
        <h6 slot="header" class="modal-title" v-if="title">
            {{ title }}
        </h6>

        <slot></slot>

        <template slot="footer">
            <slot name="footer"></slot>
        </template>
    </modal>
</template>

<script>
    export default {

        props: {
            id: {
                type: String,
                default: null
            },
            value: {
                type: Object,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            size: {
                type: String,
                default: null
            },
            bodyClasses: {
                type: String,
                default: null
            },
            modalClasses: {
                type: String,
                default: null
            },
            modalContentClasses: {
                type: String,
                default: null
            },
            centered: {
                type: Boolean,
                default: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            backdrop: {
                type: String,
                default: 'true'
            },
            animationDuration: {
                type: Number,
                default: 500
            },
        }
    }
</script>

<style scoped>

    .modal-title {
        text-transform: uppercase;
    }
    .base-modal >>> .fullscreen {
        max-width: calc(100% - 3.5rem);
    }
    .base-modal >>> .modal-footer {
        padding-top: 0;
        justify-content: center;
    }

</style>
